<template>
  <div class="rt-label-group">
    <el-checkbox-group
      v-bind="$attrs"
      v-model="selectValue"
      @change="handelChange"
    >
      <slot>
        <rt-label-item
          v-for="(item, index) in labelList"
          :label="item[valueKey]"
          :key="index"
        >
          <span>{{ item[nameKey] }}</span>
          <img src="../../assets/imgs/check-circle-fill.png" alt="" />
        </rt-label-item>
      </slot>
    </el-checkbox-group>
  </div>
</template>
<script>
export default {
  name: 'RtLabelGroup',
  props: {
    value: Array,
    labelList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    alias: {
      type: Object,
      default: () => {
        return {
          valueKey: 'value',
          nameKey: 'name'
        };
      }
    }
  },
  data() {
    return {
      selectValue: this.value
    };
  },
  computed: {
    valueKey() {
      return this.alias.valueKey;
    },
    nameKey() {
      return this.alias.nameKey;
    }
  },
  watch: {
    value(newVal, oldVal) {
      this.selectValue = newVal;
    }
  },
  methods: {
    handelChange(val) {
      this.$emit('input', val);
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtLabelGroup.vue?3ffe3f96